import MerchandisingContentServiceClient from './MerchandisingContentServiceClient';

const merchandisingContentServiceClient = new MerchandisingContentServiceClient();

export const getTenant = async (space: string): Promise<string | null> => {
  try {
    const spaces = await merchandisingContentServiceClient.getSpaces();

    if (spaces[space]) {
      return spaces[space].tenant;
    }

    return null;
  } catch (error) {
    console.error(`Error fetching tenant for space ${space}:`, error);
    return null;
  }
};
